import React from "react";

import {
DndContext,
closestCenter
} from "@dnd-kit/core";

import {
SortableContext,
useSortable,
arrayMove,
rectSortingStrategy
} from "@dnd-kit/sortable";

import {CSS} from "@dnd-kit/utilities";


function SortableImage({ img, onDelete }) {

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id: img.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (

    <div
      ref={setNodeRef}
      style={style}
      className="col-md-3 mb-3"
    >

      <div className="card">

        <img
          src={'https://api.krishnabrazing.com'+img.url}
          className="card-img-top"
          style={{ height:120, objectFit:"cover" }}
        />

        <div className="card-body text-center p-2">

          {/* DRAG HANDLE */}
          <div
            {...attributes}
            {...listeners}
            style={{
              cursor:"grab",
              fontSize:12,
              marginBottom:5
            }}
          >
            Drag
          </div>

          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={() => onDelete(img)}
          >
            Remove
          </button>

        </div>

      </div>

    </div>

  );

}


export default function SortableImageGrid({images,setImages,onDelete}){

  function handleDragEnd(event){

    const {active,over}=event;

    if(active.id!==over.id){

      const oldIndex = images.findIndex(i=>i.id===active.id);
      const newIndex = images.findIndex(i=>i.id===over.id);

      setImages(arrayMove(images,oldIndex,newIndex));

    }

  }

  return(

    <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>

      <SortableContext
        items={images.map(i=>i.id)}
        strategy={rectSortingStrategy}
      >

        <div className="row">

          {images.map(img=>(
            <SortableImage
              key={img.id}
              img={img}
              onDelete={onDelete}
            />
          ))}

        </div>

      </SortableContext>

    </DndContext>

  );

}